const roleName = (user = {}) => user.role || user.groupName || user.Group?.name || '';

export const toAuthState = (response) => {
  const user = response?.data?.user;
  if (!user || response?.error) return null;

  const role = roleName(user);
  const groupWithRoles = { name: role };
  const nestedUser = { ...user, Group: { name: role } };

  return {
    isAuthenticated: true,
    account: { userCode: user.userCode, groupWithRoles },
    userData: {
      ...user,
      groupWithRoles,
      userData: nestedUser,
    },
    isLoading: false,
  };
};
